import React from 'react';
import {
    FormControl,
    FormControlLabel,
    FormHelperText,
    FormLabel,
    Radio,
    RadioGroup,
} from '@mui/material';
import { withStyles } from '@mui/styles';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Controller, useFormContext } from 'react-hook-form';
import { COLORS } from '../../../utils/Application_Constants';

export const expenseFileSourceOptions = {
    corpay: {
        label: 'Corpay',
        value: 'corpay',
    },
    conferma: {
        label: 'Conferma',
        value: 'conferma',
    },
    travelinc: {
        label: 'Travel Inc',
        value: 'travelinc',
    },
    vault: {
        label: 'Vault',
        value: 'vault',
    },
};

const styles = () => ({
    radioLabel: {
        fontWeight: '400',
        fontSize: '14px',
        lineHeight: '20px',
    },
    formControl: {
        marginBottom: 0,
    },
    asterisk: {
        color: COLORS.LT_PEPPER,
    },
});

const ExpensesSourceRadioGroup = (props) => {
    const { classes } = props;
    const { control, errors } = useFormContext();
    const { ltoeWebExpensesEnableVaultChargesFileUpload: isVaultChargesFileUploadEnabled } =
        useFlags();

    return (
        <FormControl component="fieldset" className={classes.formControl}>
            <FormLabel
                id="source-label"
                classes={{ asterisk: classes.asterisk }}
                sx={{ fontSize: '12px', fontWeight: '700', color: '#2a3953' }}
                required
            >
                Source
            </FormLabel>
            <Controller
                control={control}
                rules={{ required: 'Source is required' }}
                defaultValue=""
                name="importer"
                render={({ onChange, value }) => (
                    <RadioGroup
                        aria-label="importer"
                        row
                        onChange={onChange}
                        value={value}
                        aria-labelledby="source-label"
                    >
                        <FormControlLabel
                            classes={{ label: classes.radioLabel }}
                            value={expenseFileSourceOptions.corpay.value}
                            control={<Radio color="primary" />}
                            label={expenseFileSourceOptions.corpay.label}
                        />
                        <FormControlLabel
                            classes={{ label: classes.radioLabel }}
                            value={expenseFileSourceOptions.conferma.value}
                            control={<Radio color="primary" />}
                            label={expenseFileSourceOptions.conferma.label}
                        />
                        <FormControlLabel
                            classes={{ label: classes.radioLabel }}
                            value={expenseFileSourceOptions.travelinc.value}
                            control={<Radio color="primary" />}
                            label={expenseFileSourceOptions.travelinc.label}
                        />
                        {isVaultChargesFileUploadEnabled && (
                            <FormControlLabel
                                classes={{ label: classes.radioLabel }}
                                value={expenseFileSourceOptions.vault.value}
                                control={<Radio color="primary" />}
                                label={expenseFileSourceOptions.vault.label}
                            />
                        )}
                    </RadioGroup>
                )}
            />
            <FormHelperText error>
                {errors && errors.importer && errors.importer.message}
            </FormHelperText>
        </FormControl>
    );
};

export default withStyles(styles)(ExpensesSourceRadioGroup);
